import { Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const PaymentMethodCardWrapper = styled.div`
  background-color: var(--color-bg-body);
  border: 2px solid
    ${({ active }) =>
      active ? 'var(--color-success-default)' : 'var(--color-accent-secondary-weaker)'};
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex-direction: column;
  padding: 16px;
  width: 416px;
`;

const PaymentMethodContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px 24px 0;
`;

const HeaderRightColumn = styled.div`
  display: flex;
`;

const PaymentMethodHeader = styled(Typography)`
  align-items: center;
  display: flex;
  justify-content: ${({ active }) => (active ? 'space-between' : 'flex-end')};
`;

const CardTitle = styled(Typography)``;

export {
  CardTitle,
  HeaderRightColumn,
  PaymentMethodCardWrapper,
  PaymentMethodContent,
  PaymentMethodHeader
};
